import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Skeleton.css';

const HeadlineSkeleton = ({
  size = 'medium',
  sizeConfined,
  sizeWide,
  width,
}) => (
  <span
    className={classnames(
      styles.element,
      styles.headline,
      styles[`headline-${size}`],
      {
        [styles[`confined-headline-${sizeConfined}`]]: sizeConfined,
        [styles[`wide-headline-${sizeWide}`]]: sizeWide,
      }
    )}
    style={{ width }}
  />
);

HeadlineSkeleton.displayName = 'HeadlineSkeleton';

HeadlineSkeleton.propTypes = {
  /** define the size of the headline */
  size: PropTypes.oneOf(['large', 'medium', 'small']),
  /** define the size of the headline for tablet and up screens */
  sizeConfined: PropTypes.oneOf(['large', 'medium', 'small']),
  /** define the size of the headline for desktop and up screens */
  sizeWide: PropTypes.oneOf(['large', 'medium', 'small']),
  /** define the size of the headline */
  width: PropTypes.number,
};

export default HeadlineSkeleton;
